import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/list${`?dueDate=${string}&workOrderIds=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/list`;

export const URL = (dueDate: string, workOrderIds: number[]): RouteDefinition => `${baseRoute}/list?dueDate=${dueDate}&workOrderIds=${encodeURIComponent((JSON.stringify(workOrderIds)))}`;
